import { Component, EventEmitter, Injector, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { T2CardComponent } from '../../../trip2-theme/components/t2-card/t2-card.component';
import { GridOptions, ICellRendererParams } from 'ag-grid';
import { PayorsService } from '../../payors/payors.service';
import { RiderService } from '../../riders/rider.service';
import { ReservationService } from '../../trip-reservations/reservations.service';
import { ParentModule } from '../ParentClass/parent-module';
import { setTimeout } from 'timers';
import { T2LoadingService } from '../../../trip2-theme/components/t2-loading/t2-loading.service';
import { modalSwal } from 'app/utils/helpers';
import { messagePermits } from '../export-functions/functions-services';
import { ToastrAlertHelper } from 'app/core/helpers/toastr-alert-helper-service';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { constant } from 'app/app.constants';
import { AdvanceSearchStateService } from 'app/services/advance-search-state.service';
import { INewSearch, ISearchCriteria, ISearchResult } from 'app/core/interfaces/advance-search.interface';

@Component({
  selector: 'app-advance-search',
  templateUrl: './advance-search.component.html',
  styleUrls: ['./advance-search.component.scss']
})
export class AdvanceSearchComponent extends ParentModule implements OnInit, OnChanges {

  private static readonly RIDER_STATUS = {
    ACTIVE: 'Active',
    INACTIVE: 'Inactive'
  };

  private static readonly STATUS_ICONS = {
    Active: 'icofont-ui-check color-success',
    Inactive: 'icofont-ui-close color-danger'
  };

  private static getRiderStatus(rowData: ISearchResult): string | null {
    const rider = rowData && rowData.advancesearchresponse;
    if (!rider || typeof rider.isinactive !== 'boolean') {
      return null;
    }
    return rider.isinactive
      ? AdvanceSearchComponent.RIDER_STATUS.INACTIVE
      : AdvanceSearchComponent.RIDER_STATUS.ACTIVE;
  }

  private static renderStatusIcon(status: string): string {
    const ico = AdvanceSearchComponent.STATUS_ICONS[status] || '';
    return `<center><i class="fa ${ico}" aria-hidden="true"></i></center> `;
  }

  public isactive = false;
  public eventP: any;
  swt: boolean;
  @Input() showTodaysTrip: boolean;
  @Input() isMergeAccount: boolean;
  @Input() enabledBtn: boolean;
  @Input() activeMerge: boolean;
  @Input() importSearch = {
    search: '',
    searchtype: 'Payor',
    payorid: 0,
    isbasic: true
  };
  @Output() accountsToMerge: EventEmitter<any> = new EventEmitter<any>();
  @Output() selectedRider: EventEmitter<any> = new EventEmitter<any>();
  @Output() clearSearch: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSearch: EventEmitter<any> = new EventEmitter<any>();
  @Output() onShowTodaysTrip: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild('searchModal') modal: T2CardComponent;
  public isClearSearch = false;
  protected searchGrid: GridOptions;
  public selectedType = 0;
  public basicSearchPtr = '';
  protected payors: any[];
  protected selectedPayor = 0;
  public  maskDate = [/[0-1]/, /[0-9]/, '-', /[0-3]/, /[0-9]/, '-', /[1-2]/, /[0-9]/, /[0-9]/, /[0-9]/];
  public selectSearch = [
    {type: 'Payor', description: 'Search by Payor', action: 'search-by-memberId-payor'},
    {type: 'Address', description: `Search by Rider's Address`, action: 'search-by-Address-Rider'},
    {type: 'Phone', description: `Search by Rider's Phone`, action: 'search-by-Phone-Rider'},
    {type: 'Dob', description: `Search by Rider's DOB`, action: 'search-by-BOB-Rider'},
    {type: 'Claim', description: `Search by Claim Number`, action: 'search-by-claim'},
    {type: 'PayorAuthorization', description: 'Search by Payor Authorization', action: 'search-by-payor-authorization'},
    {type: 'Authorization', description: 'Search by Authorization', action: 'search-by-authorization'}
    ];
  public validAction = [];
  public indexAct = 0;
  protected showLoading = false;
  newSearch: INewSearch = { firstName: '', lastName: '', reservationNumber: null };
  private pendingResults: ISearchResult[] | null = null;

  public searchTypes = {
    Payor: 'Payor',
    Address: `Address`,
    Phone: `Phone`,
    Dob: `Dob`,
    Claim: `Claim`,
    PayorAuthorization: 'PayorAuthorization',
    Authorization: 'Authorization'
  }

  first_name: any;
  last_name: any;
  activeFocus: string;
  mask = constant.MASK_PHONE2;

  constructor(
    protected payorService: PayorsService,
    protected riderService: RiderService,
    protected tripService: ReservationService,
    protected _loading: T2LoadingService,
    private inject: Injector,
    private toastrAlertHelper: ToastrAlertHelper,
    private sweetAlertHelper: SweetAlertHelper,
    private searchStateService: AdvanceSearchStateService,
    ) {
    super('app-advance-search', inject);
  }

  ngOnInit() {
    const savedCriteria = this.searchStateService.currentCriteria;
    this.pendingResults = this.searchStateService.currentResults;

    if (savedCriteria) {
      this.importSearch = savedCriteria.importSearch;
      this.newSearch = savedCriteria.newSearch || { firstName: '', lastName: '', reservationNumber: null };
      this.first_name = savedCriteria.firstName;
      this.last_name = savedCriteria.lastName;
    }

    this.payorService.getPayorsAll().subscribe(
      data => this.payors = data
    );


    this.configureGrid();

    this.actionsList$.subscribe({
      next: (actions) => {
        if (!savedCriteria) {
          this.importSearch.isbasic = !actions.includes('DisabledBasicSearch');
        }
      }
    });
  }

  onChangeShow() {
    if (this.importSearch.searchtype !== 'ridername') {
     this.avancedSearch();
      return;
    }
      this.riderService.advanceSearch(this.dataSendAvancedSearch(this.eventP)).subscribe(res => {
        const newData = this.mapDataSearch(res);
        this.verifyEmitOrCharge(newData);
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['showTodaysTrip']) {
      if (this.searchGrid) {
        this.searchGrid.columnApi.setColumnVisible('consecutive', this.showTodaysTrip);
        this.searchGrid.columnApi.setColumnVisible('tripid', this.showTodaysTrip);
        this.searchGrid.columnApi.setColumnVisible('leg', this.showTodaysTrip);
        this.searchGrid.columnApi.setColumnVisible('tripstatus', this.showTodaysTrip);
        this.searchGrid.api.setRowData([]);
        this.first_name = '';
        this.last_name = '';
        this.importSearch.search = '';
        this.importSearch.payorid = 0;
        this.newSearch = { firstName: '', lastName: '', reservationNumber: null };
        this.collapseSearchResult('');
      }
    }
  }

  public reloadGrid() {
    if (!this.importSearch.isbasic) {
      this.avancedSearch();
      return;
    }
  
    if (this.newSearch.reservationNumber) {
      this.showLoading = true;
      this.onGetRider(String(this.newSearch.reservationNumber));
      return;
    }
  
    if (
      this.newSearch.firstName &&
      this.newSearch.firstName.trim() &&
      this.newSearch.lastName &&
      this.newSearch.lastName.trim()
    ) {
      this.showLoading = true;
      this.onGetRider(
        `${this.newSearch.firstName.trim()}|${this.newSearch.lastName.trim()}`
      );
    }
  }

  public returnSelectedRider(event) {
    this.selectedRider.emit(event.data.advancesearchresponse);
    this.isClearSearch = false;
    this.collapseSearchResult('');
  }

  public returnArrayRiders() {
    const arrayData = this.searchGrid.api.getSelectedNodes().map((item) => {
      item.data['riderid'] = item.data.advancesearchresponse.riderid;
      return item.data;
    });
    this.accountsToMerge.emit(arrayData);

  }
  showModal(): void {
    this.modal.open('lg');
  }
  private configureGrid() {
    const me = this;
    this.searchGrid = <GridOptions>{};
    this.searchGrid.enableColResize = true;
    const columns: any[] = [{
        headerName: 'Rider Id',
        field: 'advancesearchresponse.riderid',
        colId: 'riderid',
        width: 70
      },
      {
        headerName: 'Name',
        field: 'advancesearchresponse.name',
        colId: 'name',
        width: 200
      },
      {
        headerName: 'Status',
        colId: 'status',
        width: 70,
        valueGetter: (params: { data: ISearchResult }) =>
          AdvanceSearchComponent.getRiderStatus(params && params.data),
        cellRenderer: (params: ICellRendererParams) =>
          AdvanceSearchComponent.renderStatusIcon(params && params.value),
      },
      {
        headerName: 'Reservation',
        field: 'consecutive',
        colId: 'consecutive',
        width: 80,
        hide: !this.showTodaysTrip
      },
      {
        headerName: 'Trip´ID',
        field: 'tripid',
        colId: 'tripid',
        width: 70,
        hide: !this.showTodaysTrip
      },
      {
        headerName: 'Leg',
        field: 'leg',
        colId: 'leg',
        width: 50,
        hide: !this.showTodaysTrip
      },
      {
        headerName: 'Status',
        field: 'tripstatus',
        colId: 'tripstatus',
        width: 60,
        hide: !this.showTodaysTrip
      },
      {
        headerName: 'DOB',
        field: 'advancesearchresponse.dob',
        colId: 'dob',
        width: 80
      },
      {
        headerName: 'Address',
        field: 'advancesearchresponse.address',
        colId: 'address',
        width: 200,
      },
      {
        headerName: 'Phone',
        field: 'advancesearchresponse.phone',
        colId: 'phone',
        width: 100,
      },
      {
        headerName: 'Payor',
        field: 'advancesearchresponse.payor',
        colId: 'payor',
        width: 180,
      },
      {
        headerName: 'Member Id',
        field: 'advancesearchresponse.memberid',
        colId: 'memberid',
        width: 150,
      },
      {
        headerName: 'Medicaid Number',
        field: 'advancesearchresponse.medicaidnumber',
        colId: 'medicaid',
        width: 150,
      },
      {
        headerName: 'Start Date',
        field: 'advancesearchresponse.startdateformatted',
        colId: 'startdate',
        width: 150,
      },
      {
        headerName: 'End Date',
        field: 'advancesearchresponse.expirationdateformatted',
        colId: 'enddate',
        width: 150,
      }
    ];
    if (this.activeMerge && me.isMergeAccount) {
      this.searchGrid.rowSelection = 'multiple';
      columns.unshift({
        headerName: 'Sel',
        colId: 'id',
        width: 50,
        checkboxSelection: true,
        headerCheckboxSelection: false,
      });
    }

    this.searchGrid.columnDefs = columns;

  }

  public search(event) {
    this.newSearch.reservationNumber = null;
    const value: string = event.target.value;
    this.onSearch.emit(true);
    if (value.length > 3 && event.key === 'Enter' && !this.showLoading) {
      this._loading.show();
      this.avancedSearch();
      this.showLoading = true;
    } else {
      this.collapseSearchResult(value);
    }
  }

  private getBackedObject() {
    if (this.newSearch.reservationNumber) {
      this.importSearch.search = String(this.newSearch.reservationNumber);
    }
    const data = {
      search: this.importSearch.search,
      searchtype: this.importSearch.searchtype,
      payorid: this.importSearch.payorid,
      allriders: this.isactive
    };
    if (!['Payor', 'PayorAuthorization'].includes(data.searchtype)) {
      delete data.payorid;
    }
    return data;
  }

  searchByClaim(event) {
    if (event.key === 'Enter' && this.importSearch.search) {
      this.showLoading = true;
      this._loading.show();
      this.riderService.advanceSearch(this.dataSendAvancedSearch(this.importSearch.search)).subscribe(success => {
        this.showLoading = false;
        this._loading.hiden();
        if (success.trip) {
          this.selectedRider.emit(success.trip);
          this.isClearSearch = false;
          this.collapseSearchResult('');
        } else {
          modalSwal('Search claim number', 'info', 'Claim number not found');
        }
      }, error => {
        modalSwal('error', 'error', error.message).then(() => {
          this.showLoading = false;
          this._loading.hiden();
        });
      });
    }
  }

  onClickAdvanceSearch() {
    if (this.activeFocus === 'reservationNumber') {
      this.clearInputsSearch();
    } else {
      this.newSearch.reservationNumber = null;
    }
    this.validateInput();
    if (this.swt) {
      this.showLoading = true;
      const valueSearch = this.importSearch.search.replace(/\s*$/, '');
      this.onGetRider(valueSearch);
      this.collapseSearchResult(valueSearch);
    }
    this.importSearch.search = '';
  }

  public basicSearch(event) {
    if (this.validateEvent(event)) {
      if (this.importSearch.search) {
        const value = `${'' + this.importSearch.search.trim()}`;
        this.onGetRider(value);
      }
    } else {
      this.collapseSearchResult(event.target.value.trim());
    }
    this.importSearch.search = '';
  }

  resetInput(id, input) {
    switch (id) {
      case 'firstName':
        this.newSearch.firstName = input.value;
        break;
      case 'lastName':
        this.newSearch.lastName = input.value;
        break;
      case 'reservationNumber':
        Number(input.value) === 0 ? this.newSearch.reservationNumber = null : this.newSearch.reservationNumber = Number(input.value);
        break;
      default:
        break;
    }
  }

  validateInput() {
    const pattern = /^[A-Za-z\s]+$/;
  if ((this.newSearch.firstName.trim().length && !this.newSearch.firstName.match(pattern)) ||
      (this.newSearch.lastName.trim().length && !this.newSearch.lastName.match(pattern))) {
      this.sweetAlertHelper.createCustomAlert({text: 'Only text allowed in this field', type: 'warning'});
      return;
    }

    if (this.newSearch.firstName.trim().length && this.newSearch.lastName.trim().length) {
      this.validateLengthInput();
      const value = `${this.newSearch.firstName.trim()}|${this.newSearch.lastName.trim()}`;
      if (this.swt) {
        this.importSearch.search = value;
      }
    } else if (this.newSearch.reservationNumber) {
      const value = `${'' + this.newSearch.reservationNumber}`;
      this.importSearch.search = value.trim();
      this.swt = true;
    }

    if (!this.newSearch.reservationNumber) {
      if (!this.newSearch.firstName.trim().length) {
        this.sweetAlertHelper.createCustomAlert({text: 'First Name Is Required', type: 'warning'});
      } else if (!this.newSearch.lastName.trim().length) {
        this.sweetAlertHelper.createCustomAlert({text: 'Last Name Is Required', type: 'warning'});
      }
    }
  }

  validateLengthInput() {
    if (this.newSearch.firstName.length < 3 || this.newSearch.lastName.length < 3) {
      this.sweetAlertHelper.createCustomAlert({text: 'The Min. Character is 3', type: 'warning'});
      this.swt = false;
    } else {
      this.swt = true;
    }
  }

  onGetRider(event) {
    this.eventP = event;
    if (this.newSearch.reservationNumber) {
      this.importSearch.searchtype = 'consecutive';
    } else {
      this.importSearch.searchtype = 'ridername';
    }
    if (event) {
      this.showLoading = true;
      this.onSearch.emit(true);
      this.riderService.advanceSearch(this.dataSendAvancedSearch(event)).subscribe(
        data => {
          if (Object.keys(data).length) {
            if (data.trip) {
              this.verifyEmitOrCharge(data);
            } else {
              if (data.riders) {
                const newData = data.riders.map((item) => {
                  const item2 = {
                    advancesearchresponse: item
                  };
                  return item2;
                });
                this.verifyEmitOrCharge(newData);
              }
            }
          } else {
            this.verifyEmitOrCharge([]);
          }
          this.showLoading = false;
        },
        error => {
          modalSwal('error', 'error', error.message).then(() => { this.showLoading = false; });
        }
      );
    } else {
      this.showLoading = false;
    }
  }

  /**@name verifyEmitOrCharge
   * @description Verifica si trae riders o emite trips
   * @param data = array datos de riders o rider-trips
   * **/
  verifyEmitOrCharge(data) {
    if (data.trip) {
      this.selectedRider.emit(data.trip);
      this.collapseSearchResult('');
    } else {
      if (this.searchGrid.api) {
        this.searchGrid.api.setRowData(data);
        this.saveSearchState(data);
        this.expandSearchResult();
      }
    }
  }

  expandSearchResult() {
    this.isClearSearch = true;
  }
  collapseSearchResult(value) {
    if (value === '') {
      this.isClearSearch = false;
    }
  }

  private validateEvent(event) {
    if (event.key === 'Enter' && !this.showLoading) {
      this.validateInput();
      return true;
    }
    return false;
  }

  public onGridReady() {
    if (
      this.pendingResults &&
      this.pendingResults.length &&
      this.searchGrid &&
      this.searchGrid.api
    ) {
      this.searchGrid.api.setRowData(this.pendingResults);
      this.expandSearchResult();
      this.pendingResults = null;
    }
  }

  switchClearSearch() {
    this.clearSearch.emit();
    this.isClearSearch = false;
    this.importSearch.search = '';
    this.importSearch.payorid = 0;
    this.first_name = '';
    this.last_name = '';

    this.newSearch = { firstName: '', lastName: '', reservationNumber: null };

    this.importSearch.isbasic = !this.isAllowedAction('DisabledBasicSearch');
    this.collapseSearchResult('');
    this.searchStateService.clear();
  }
  public switchSearch() {
    if (!this.isAllowedAction('DisabledBasicSearch')) {
      this.showTodaysTrip = false;
      this.first_name = '';
      this.last_name = '';
      this.onShowTodaysTrip.emit(false);
      this.importSearch.isbasic = !this.importSearch.isbasic;
      if (this.importSearch.isbasic) {
        this.importSearch.searchtype = 'Payor';
      }
      this.persistCriteria();
      this.changeValueSearch(this.validAction[0]);
    } else {
      messagePermits('Error');
    }
  }

  /**
   * @name verifyAction
   * @description verifica si la accion esta permitida
   */
   verifyAction(action, type) {
    if (this.indexAct < 7) {
      this.selectSearch.forEach((val, i) => {
        if (type === val.type && action) {
          this.validAction.push(val.type);
        }
      });
      if (this.validAction.length === 1) {
        this.changeValueSearch(this.validAction[0]);
      }
    }
    this.indexAct++;
    return action;
   }

  /**
   * @name changeValueSearch
   * @description modifica segun el cambio
   */
  changeValueSearch(value) {
    if (!this.importSearch.isbasic && value) {
    setTimeout(val => { this.importSearch['searchtype'] = value; }, 250);
    }
  }

  public resetSearch(event?) {
    this.importSearch.search = '';
    if (this.importSearch.isbasic) {
      this.importSearch.searchtype = 'Payor';
    }
  }

  onSearchTripTpday() {
    if (this.first_name && this.last_name) {
      this.showLoading = true;
      this.onSearch.emit(true);
      this.tripService.getTodayTripsForReservation(this.first_name + '-' + this.last_name).subscribe(
        data => {
          if (this.searchGrid) {
            if (this.searchGrid.api) {
              this.searchGrid.api.setRowData(data);
              this.saveSearchState(data);
            }
          }

          this.showLoading = false;
          this.expandSearchResult();
        }, error1 => {
          this.showLoading = false;
          this.toastrAlertHelper.error(error1.message);
        });
    }
  }

  onKeyEnter($event) {
    const keycode = ($event.keyCode ? $event.keyCode : $event.which);
    if (keycode === 13) {
      this.onSearchTripTpday();
      return false;
    }
  }

  onChangePayor() {
  }

  private persistCriteria(): void {
    if (this.showTodaysTrip) { return; }
    const criteria: ISearchCriteria = {
      importSearch: Object.assign({}, this.importSearch),
      newSearch: Object.assign({}, this.newSearch),
      firstName: this.first_name,
      lastName: this.last_name
    };
    this.searchStateService.updateCriteria(criteria);
  }

  private saveSearchState(results: ISearchResult[]): void {
    if (this.showTodaysTrip) { return; }
    this.persistCriteria();
    this.searchStateService.updateResults(results);
  }

  focusActive(event) {
    this.activeFocus = event.target.name;
  }

  clearInputsSearch() {
    this.newSearch.firstName = '';
    this.newSearch.lastName = '';
  }

  dataSendAvancedSearch(event) {
    return {
      allriders: this.isactive,
      search: event,
      searchtype: this.importSearch.searchtype
    };
  }

  avancedSearch() {
    this.riderService.advanceSearch(this.getBackedObject())
      .finally(() => {
        this._loading.hiden();
        this.showLoading = false;
      })
      .subscribe(
        data => {
          const isAuthorizationSearch = ['Authorization', 'PayorAuthorization'].includes(this.importSearch.searchtype);
          if (!isAuthorizationSearch) {
            const newData = this.mapDataSearch(data);
            if (this.searchGrid.api) {
              this.searchGrid.api.setRowData(newData);
              this.saveSearchState(newData);
            }
            this.expandSearchResult();
            return;
          }

          const hasTripData = Object.keys(data).length;
          if (!hasTripData) {
            if (this.searchGrid.api) {
              this.searchGrid.api.setRowData([]);
              this.saveSearchState([]);
            }
            this.expandSearchResult();
            return;
          }

          this.verifyEmitOrCharge(data);
        },
        error => this.sweetAlertHelper.captureException(error)
    );
  }

  mapDataSearch(res: { riders: any[]; }) {
    return res.riders.map((item) => ({ advancesearchresponse: item }));
  }

  get showBasicSearch(): boolean {
    return this.importSearch.isbasic && !this.isAllowedAction('DisabledBasicSearch');
  }

  get payorIsNotSelected() {
    return !this.importSearch || !this.importSearch.payorid;
  }

  validateSearchType(searchtype: string, type: string): boolean {
    return searchtype === type;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/advance-search/advance-search.component.ts